import { SadPage } from "../../../components/SadPage"

type Props = {
  kioskMode?: boolean
}

export function InvitationExpiredPage({ kioskMode }: Props) {
  return (
    <SadPage
      kioskMode={kioskMode}
      lines={[
        "It seems like your invitation to provide feedback on your last session has expired.",
      ]}
    />
  )
}
